import { gql } from '@apollo/client'

export const BASKET_FRAGMENT = gql`
  fragment CartBasket on Basket {
    id
    discounts {
      code
    }
    requiresShipping
    lineItems {
      id
      discount {
        value
        currencyCode
      }
      price {
        value
        currencyCode
      }
      product {
        id
        slug
        image {
          url
        }
      }
      quantity
      variant {
        id
        maxQuantity
        title
        options {
          name
          value
        }
      }
    }
    subtotal {
      value
      currencyCode
    }
    total {
      value
      currencyCode
    }
    totalDiscount {
      value
      currencyCode
    }
    value {
      value
      currencyCode
    }
  }
`

export const BASKET = gql`
  query CartBasket {
    basket {
      ...CartBasket
    }
  }

  ${BASKET_FRAGMENT}
`
